import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import PremierPartners from './components/PremierPartners';
import IntegrationCapabilities from './components/IntegrationCapabilities';
import CertificationTimeline from './components/CertificationTimeline';
import JointCaseStudies from './components/JointCaseStudies';
import PartnerTestimonials from './components/PartnerTestimonials';
import InnovationLab from './components/InnovationLab';
import CTASection from './components/CTASection';

const Partners = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-1">
        <HeroSection />
        <PremierPartners />
        <IntegrationCapabilities />
        <CertificationTimeline />
        <JointCaseStudies />
        <PartnerTestimonials />
        <InnovationLab />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Partners;